import { render, staticRenderFns } from "./MultipleSelectBox.vue?vue&type=template&id=115392d6&scoped=true"
import script from "./MultipleSelectBox.vue?vue&type=script&lang=ts"
export * from "./MultipleSelectBox.vue?vue&type=script&lang=ts"
import style0 from "./MultipleSelectBox.vue?vue&type=style&index=0&id=115392d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115392d6",
  null
  
)

export default component.exports